export default "__VITE_ASSET__CQ57NENb__"